import { Link } from 'react-router-dom';
import { EstimationGame } from '../components/EstimationGame';
import { Layout } from '../components/Layout';

const estimationItems = [
  {
    title: 'Modernes Alpenchalet bei Meran',
    image: 'https://images.unsplash.com/photo-1734169065204-127b2b724c7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBhbHBpbmUlMjBob3VzZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzQyNTc4NzZ8MA&ixlib=rb-4.1.0&q=85',
    description: 'Neuwertiges Chalet mit modernem Design, Bergblick und großem Grundstück.',
    details: ['180 m² Wohnfläche', '1.200 m² Grund', 'Baujahr 2022', 'Bergblick'],
    question: 'Was schätzt du, kostet dieses Haus?',
    actualValue: 850000,
    minValue: 400000,
    maxValue: 1500000,
    step: 25000,
    explanation: 'Traditionelle Bauernhäuser in der Nähe von Meran mit dieser Ausstattung liegen typischerweise zwischen 750.000 und 950.000 Euro, abhängig von Zustand und Lage.'
  },
  {
    title: 'Moderne Wohnung in Bozen',
    image: 'https://images.unsplash.com/photo-1760072513442-9872656c1b07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwZGVzaWdufGVufDB8fHx8MTc3NDI1Nzg3OXww&ixlib=rb-4.1.0&q=85',
    description: '3-Zimmer-Wohnung im Neubau mit Balkon und Tiefgarage in zentraler Lage.',
    details: ['95 m² Wohnfläche', 'Neubau', 'Balkon', 'Tiefgarage'],
    question: 'Was kostet diese Wohnung?',
    actualValue: 520000,
    minValue: 250000,
    maxValue: 800000,
    step: 20000,
    explanation: 'Neubauwohnungen in Bozen-Zentrum kosten durchschnittlich 5.000-6.000 Euro pro Quadratmeter. Diese 95-m²-Wohnung liegt damit im typischen Bereich.'
  },
  {
    title: 'Luxus-Chalet mit Dolomiten-Blick',
    image: 'https://images.unsplash.com/photo-1742130754462-f83b21dcc54f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhbHBpbmUlMjBob3VzZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzQyNTc4NzZ8MA&ixlib=rb-4.1.0&q=85',
    description: 'Luxuriöses Holzchalet mit direktem Panoramablick auf die Dolomiten.',
    details: ['220 m² Wohnfläche', '800 m² Grund', 'Sauna & Wellness', 'Panoramablick'],
    question: 'Wie viel ist dieses Chalet wert?',
    actualValue: 1450000,
    minValue: 600000,
    maxValue: 2500000,
    step: 50000,
    explanation: 'Premium-Chalets mit Dolomiten-Blick sind sehr begehrt. Die Kombination aus Lage, Ausstattung und Aussicht rechtfertigt Preise von 1,2 bis 1,8 Millionen Euro.'
  },
  {
    title: 'Sanierungsbedürftiges Stadthaus',
    image: 'https://images.unsplash.com/photo-1665069181618-5618c9b621ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxob21lJTIwcmVub3ZhdGlvbiUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnMlMjBtb2Rlcm58ZW58MHx8fHwxNzc0MjU3ODc5fDA&ixlib=rb-4.1.0&q=85',
    description: 'Historisches Stadthaus mit viel Potenzial, aber umfassender Sanierungsbedarf.',
    details: ['150 m² Wohnfläche', 'Sanierungsbedürftig', 'Zentrale Lage', 'Denkmalschutz'],
    question: 'Was würdest du für dieses Objekt zahlen?',
    actualValue: 380000,
    minValue: 150000,
    maxValue: 700000,
    step: 20000,
    explanation: 'Sanierungsobjekte sind günstiger im Einkauf, erfordern aber oft 150.000-300.000 Euro zusätzliche Investition. Der Denkmalschutz kann Vor- und Nachteile haben.'
  }
];

const relatedLinks = [
  { path: '/ratgeber/hausbau-in-suedtirol', label: 'Hausbau in Südtirol' },
  { path: '/tippspiele/neubau-oder-sanierung', label: 'Neubau oder Sanierung?' },
  { path: '/haus-und-bau/was-kostet-eine-sanierung', label: 'Was kostet eine Sanierung?' }
];

export default function WasKostetDiesesHaus() {
  return (
    <div className="section-spacing" data-testid="was-kostet-page">
      <div className="container-wide">
        {/* Breadcrumb */}
        <nav className="text-sm text-[#64748B] mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-[#0284C7]">Start</Link>
          <span className="mx-2">/</span>
          <Link to="/tippspiele" className="hover:text-[#0284C7]">Tippspiele</Link>
          <span className="mx-2">/</span>
          <span className="text-[#0F172A]">Was kostet dieses Haus?</span>
        </nav>

        <EstimationGame
          title="Was kostet dieses Haus?"
          introText="Schätze den Wert von Immobilien in Südtirol. Je näher deine Schätzung am tatsächlichen Wert liegt, desto mehr Punkte bekommst du!"
          items={estimationItems}
          unit="€"
          relatedLinks={relatedLinks}
        />

        {/* SEO Content */}
        <div className="mt-16 advisor-content">
          <h2>Immobilienpreise in Südtirol verstehen</h2>
          <p>
            Der Immobilienmarkt in Südtirol ist besonders: Die Kombination aus begrenztem Bauland, 
            hoher Lebensqualität und der Attraktivität als Zweitwohnsitz-Region sorgt für 
            überdurchschnittliche Preise im italienischen Vergleich.
          </p>
          
          <h3>Was bestimmt den Preis?</h3>
          <ul>
            <li><strong>Lage:</strong> Meran, Bozen und die Dolomiten-Regionen sind am teuersten</li>
            <li><strong>Zustand:</strong> Sanierungsbedarf kann den Preis um 30-50% senken</li>
            <li><strong>Ausstattung:</strong> Energieeffizienz und moderne Standards werden belohnt</li>
            <li><strong>Aussicht:</strong> Panoramablick kann den Wert um 10-20% steigern</li>
          </ul>

          <p>
            Du planst einen Immobilienkauf in Südtirol? Ein erfahrener Makler wie{' '}
            <a href="https://amadeus.immo" target="_blank" rel="noopener noreferrer">
              amadeus.immo
            </a>{' '}
            kann dir helfen, den fairen Marktwert einzuschätzen und die richtige Immobilie zu finden.
          </p>

          <div className="cta-box">
            <div className="cta-box-title">Nächster Schritt: Finanzierung planen</div>
            <p className="cta-box-text">
              Du weißt jetzt ungefähr, was Immobilien kosten. Der nächste Schritt ist die 
              Finanzierungsplanung – wie viel Eigenkapital brauchst du?
            </p>
            <Link to="/immobilien/wohnung-kaufen-oder-mieten" className="text-[#0284C7] font-medium hover:underline">
              Zum Quiz: Kaufen oder Mieten? →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
